var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftPartialGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: 6,
    width: "100%",
    height: 43,
    rx: 12,
    fill: "transparent",
    stroke: "url(#btn-outlined-gradient)",
    filter: "url(#glow)",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: 6,
    width: "100%",
    height: 43,
    rx: 12,
    fill: "transparent",
    stroke: "url(#btn-outlined-gradient)",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPartialGlow);
export default __webpack_public_path__ + "static/media/leftPartialGlow.57d669337b2336767296004e870b96c1.svg";
export { ForwardRef as ReactComponent };